import { timeSpanFormatString } from 'owa-locstrings/lib/strings/timespanformatstring.locstring.json';
import loc, { format } from 'owa-localize';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    differenceInDays,
    formatMonthDay,
    formatMonthDayShortTime,
    formatShortTime,
    isAllDayEvent,
    getDate,
} from 'owa-datetime';
import { getCalendarEventDateRangeVisualDateRange } from 'owa-calendar-events-visual-date-range';

/**
 * Gets the text to show in the info tip during a drag operation
 * @param itemModel The updated item model with the new start and end dates
 * @returns The formatted start and end date of the event
 */
export function getDragInfoTipText(
    itemModel: CalendarEvent,
    startEndFormatString: string = loc(timeSpanFormatString)
): string {
    if (!itemModel) {
        return '';
    }
    let start = itemModel.Start;
    let end = itemModel.End;
    let isAllDay = isAllDayEvent(start, end);

    if (isAllDay && differenceInDays(start, end) === -1) {
        return formatMonthDay(start);
    }

    let formattedStart = '';
    let formattedEnd = '';
    if (isAllDay) {
        // Multi-day all day event
        formattedStart = formatMonthDay(start);
        const visualEndDate = getCalendarEventDateRangeVisualDateRange({ start: start, end: end })
            .end;
        formattedEnd = formatMonthDay(visualEndDate);
    } else if (getDate(start) != getDate(end)) {
        // Multi day > 24 (custom duration) or multi-day < 24h (April 25 3:00p - April 26 2:00p )
        formattedStart = formatMonthDayShortTime(start);
        formattedEnd = formatMonthDayShortTime(end);
    } else {
        // Same day event < 24h (April 25 3:00p - 4:00p)
        formattedStart = formatMonthDayShortTime(start);
        formattedEnd = formatShortTime(end);
    }
    return format(startEndFormatString, formattedStart, formattedEnd);
}
